import type { AdminActionRequestDto } from '@/api/generated';

import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Req = {
  adminUserId: string;
  candidateId: string;
  dto: AdminActionRequestDto;
};

type Response = void;

type Return = {
  invokeAdminAction: (req: Req) => Promise<Response>;
  isInvoking: boolean;
};

export const useInvokeAdminAction = (): Return => {
  const { adminCandidatesApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<Response, AxiosError, Req>({
    mutationFn: async req => {
      await adminCandidatesApi.invokeAdminAction(req.adminUserId, req.candidateId, req.dto);
    },
  });

  return {
    invokeAdminAction: mutateAsync,
    isInvoking: isPending,
  };
};
